<template>
  <div class="bg-ontick-graphite-700 grid grid-cols-9 last:rounded-b-lg">
    <div class="td">
      <span class="sr-only"> Sem ações disponíveis </span>
    </div>
    <div class="td !justify-start">
      <product-type-component :type="investment.type" />
    </div>
    <div
      class="td w-48 max-w-full !justify-start space-x-1 !pr-0 !text-left font-semibold"
      :class="nameColumnSize"
    >
      <img
        :src="investment.partner_badge"
        v-if="investment.partner_badge"
        class="h-4 w-4"
      />
      <p
        class="w-full truncate"
        :content="investment.strategy_name"
        v-tippy="{ arrow: true, theme: 'green' }"
      >
        {{ investment.strategy_name }}
      </p>
    </div>
    <div class="td">
      <span v-if="investment.strategy_symbol === 'PORTFOLIO'">
        {{ investment.strategy_symbol }}
      </span>
      <span
        v-else
        class="bg-ontick-teal-600 text-ontick-teal-50 rounded px-2 py-1"
      >
        {{ investment.strategy_symbol }}
      </span>
    </div>
    <div class="td">
      {{ investment.position_volume ? investment.position_volume : "-" }}
    </div>
    <div class="td font-bold uppercase">
      {{ investment.position_status }}
    </div>
    <div class="td">
      {{ investment.closed_pnl | currency }}
    </div>
    <div class="td">
      {{ investment.open_pnl }}
    </div>
  </div>
</template>

<script>
import * as icons from "@/app/assets/icons/investments";
import OntickToggleComponent from "../../../ontick-toggle/ontick-toggle.component.vue";
import statusIndicatorComponent from "../../card-investment/status-indicator.component.vue";
import ProductTypeComponent from "../product-type.component.vue";

export default {
  components: {
    OntickToggleComponent,
    statusIndicatorComponent,
    ProductTypeComponent,
  },

  props: {
    investment: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      toggle_disabled: true,

      typed_volume: this.investment.curr_volume,

      optionDefault: {
        icon: icons.details,
        label: null,
      },
      optionsSelect: [
        { icon: icons.editParams, label: "Parâmetros" },
        { icon: icons.performance, label: "Histórico" },
        {
          icon: icons.removeInvestment,
          label:
            this.investment.status != "HIDDEN" ? "Arquivar" : "Desarquivar",
        },
      ],
      activeColumns: localStorage.getItem("listModeColumns")
        ? localStorage.getItem("listModeColumns").split(",")
        : null,
    };
  },

  computed: {
    nameColumnSize() {
      if (this.investment.status === "RUNNING") {
        return this.activeColumns.length > 6 ? "col-span-1" : "col-span-2";
      } else {
        return "col-span-2";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.td {
  @apply text-ontick-carbon-900 flex items-center justify-center px-4 py-1.5 text-center text-sm dark:text-gray-300;
}
.slide-in {
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
  &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
    @apply -translate-y-full transform opacity-0;
  }
}
</style>
